import React, { useEffect } from "react";
import styled from "styled-components";
import FollowButton from "./FollowButton";
import ProfileIcon from "../mobile/ProfileIcon";
import comment from "../../assets/comment.png";
import like from "../../assets/like.png";

const UserName = styled.div`
  font-size: 14px;
  font-weight: 600;
  font-family: "Poppins";
  padding-bottom: 8px;
  z-index: 1;
  margin-top: 14px;
`;

const Caption = styled.div`
  font-weight: 500;
  font-size: 12px;
  font-family: "Inter";
  margin-bottom: 30px;
  max-width: 300px;
  margin-top: 8px;
`;

const VideoHolder = styled.video`
  max-height: 100%;
  border-radius: 4px;
  max-width: 100%;
`;

const Button = styled.a`
  background: linear-gradient(183.1deg, #59c5e8 -40.07%, #5a8ef1 98.5%);
  padding: 8px 16px;
  border-radius: ${(props) => (props.rounded ? "10000px" : "4px")};
  font-size: 14px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  border-bottom: 0.99px solid rgba(65, 65, 98, 1);
  padding: 40px 0px;
  position: relative;
  max-width: 700px;
`;

export default function VideoCard({ openModal,video, user, showUserImage=true}) {
  const CtaButton = ({ count, img }) => {
    return (
      <a
        onClick={() => {
        openModal()
        }}
        style={{ textAlign: "center" }}
      >
        <img src={img} />
        <div style={{ textAlign: "center", marginBottom: 16 }}>{count}</div>
      </a>
    );
  };

  return (
    <Container>
      {showUserImage && <ProfileIcon img={user.pictureUri} />}
      <div
        style={{
          margin: "0px 16px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-evenly",
        }}
      >
        <UserName>@{user.username}</UserName>
        <Caption>{video.caption}</Caption>
        <VideoHolder controls src={video.videoUri.replace('napp-media.s3.amazonaws.com', 'cdn-m.namasteapis.com').replace('napp-media.s3.ap-south-1.amazonaws.com',  'cdn-m.namasteapis.com')} />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          position: 'relative',
          marginLeft: 12
        }}
      >
        <FollowButton openModal={openModal} />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
          }}
        >
          <CtaButton img={like} count={video.likes} />
          <CtaButton img={comment} count={video.comments} />
        </div>
      </div>
    </Container>
  );
}
